import { ContactFormData } from '@/components/contact/ContactForm.types';
import { supabase } from '@/integrations/supabase/client';

export interface ContactFormResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export const submitContactForm = async (data: ContactFormData): Promise<ContactFormResponse> => {
  try {
    const { data: result, error } = await supabase.functions.invoke('send-contact-form', {
      body: data,
    });

    if (error) {
      throw new Error(error.message || 'Failed to send message');
    }

    return {
      success: true,
      message: 'Message sent successfully'
    };
  } catch (error) {
    console.error('Contact form submission error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to send message'
    };
  }
};
